// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__ytAvT","imageUploader":"EGiftCard_imageUploader__1wntd"};